import { all } from "redux-saga/effects";
import { saga as getEssentialServicesGeojson } from "./actions/getEssentialServicesGeojson";

export default all([getEssentialServicesGeojson]);
